<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить скидку</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'discounts' }">← Назад к Скидкам</router-link>
    </div>

    <discount-add-form @after="handleAfter" />

  </div>
</template>

<script>
import discountAddForm from '@/components/forms/discount/DiscountAddForm'

export default {
  name: 'discount-add',
  components: { discountAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'discounts' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DiscountAdd.vue?5d85c8f0